import styled from 'styled-components'
import { colors } from 'globalStyles'

export const Card = styled.div`
  background: ${colors.primary_white};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  padding: 0;
  margin-bottom: 8px;
`

export const HeaderWrapper = styled.div`
  border-bottom: 2px solid ${colors.web_lighter_grey};
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0;
  padding: 16px;
`

export const PackageInfo = styled.div`
  flex: 1;
`
export const TrackingNumber = styled.div`
  font-size: 0.875rem;
  margin-top: 4px;
`

export const VendorLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 1rem;
  width: 8rem;
  height: 3rem;

  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    aspect-ratio: 3/2;
    object-fit: contain;
    object-position: right center;
  }
`

export const DeliveryInfo = styled.div`
  margin-bottom: 0;
  padding: 16px;
  border-bottom: 2px solid ${colors.web_lighter_grey};
`

export const EstimatedDelivery = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 500;
  color: ${colors.primary_blue};
`

export const Status = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 400;
  background-color: ${(props) => {
    switch (props.status) {
      case 'Picked Up':
        return colors.statusPickedUp
      case 'Out For Delivery':
        return colors.statusOutForDelivery
      case 'Delivered':
        return colors.statusDelivered
      case 'Delayed':
        return colors.statusDelayed
      default:
        return colors.statusAllInactive
    }
  }};
  color: ${colors.primary_black};
`

export const DeliveryDate = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: ${colors.primary_black};
  font-size: 18px;
`

export const DateText = styled.span`
  font-weight: 600;
`

export const TimeText = styled.span`
  font-weight: 400;
  color: ${colors.web_dark_grey};
`

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;

  svg {
    width: 100%;
    height: 100%;
  }
`

export const ChevronIcon = styled(IconWrapper)`
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.2s ease;
`

export const Address = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 400;
  padding-left: 24px;
`

export const PreferencesSection = styled.div`
  border-top: none;
  margin-top: 0px;
  margin-bottom: 0px;
  padding: 0;
`

export const PreferencesButton = styled.button`
  width: 100%;
  padding: 16px;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: ${colors.primary_blue};
  font-weight: 600;
  font-size: 16px;

  &:hover {
    background-color: ${colors.web_lighter_grey};
  }
`
